module.exports = __webpack_public_path__ + "img/camera.a7fda1de.png";